import * as yup from 'yup';
import { CustomsUserType, CustomsReasonToExport } from '@packlink/packlink-sdk';
import { getIsSelectOption, getSelectValidator } from '../../utils/select.js';

const MAX_DOCUMENT_WEIGHT = 5;
const MAX_DOCUMENT_WEIGHT_ERROR = 'max-document-weight';
const isVatStatusCompany = getIsSelectOption(CustomsUserType.COMPANY);
const isVatStatusPrivatePerson = getIsSelectOption(CustomsUserType.PRIVATE_PERSON);
function getRequiredErrorMessage(field, t) {
  return t('form.error.required', {
    field: t(field)
  });
}
const getCompanyTaxFormValidation = t => yup.string().when('vatStatus', {
  is: isVatStatusCompany,
  then: yup.string().required(getRequiredErrorMessage('customs-form.tax-info.company-label', t)),
  otherwise: yup.string().nullable()
});
const getEoriTaxFormValidation = () => yup.string().nullable();
const getVatNumberTaxFormValidation = t => yup.string().when('vatStatus', {
  is: isVatStatusCompany,
  then: yup.string().required(getRequiredErrorMessage('customs-form.tax-info.vat-number-label', t)),
  otherwise: yup.string().nullable()
});
const getTaxIdTaxFormValidation = (type, t) => type === 'sender' ? yup.string().when('vatStatus', {
  is: isVatStatusPrivatePerson,
  then: yup.string().required(getRequiredErrorMessage('customs-form.tax-info.tax-id-label', t)),
  otherwise: yup.string().optional()
}) : yup.string().optional();
const getVatStatusTaxFormValidation = t => yup.object().nullable().test('vat-status-required', getRequiredErrorMessage('customs-form.tax-info.vat-status-label', t), getSelectValidator(Object.values(CustomsUserType))).required();
const getTaxFormValidation = (type, t) => yup.object().shape({
  vatStatus: getVatStatusTaxFormValidation(t),
  company: getCompanyTaxFormValidation(t),
  taxId: getTaxIdTaxFormValidation(type, t),
  vatNumber: getVatNumberTaxFormValidation(t),
  eori: getEoriTaxFormValidation()
}).defined();
const getReasonsToExportValidation = (t, customsInventoryMaxWeight) => yup.object().nullable().test('reasons-to-export-required', getRequiredErrorMessage('customs-form.tax-info.export-reason-label', t), getSelectValidator(Object.values(CustomsReasonToExport))).test({
  name: MAX_DOCUMENT_WEIGHT_ERROR,
  message: t('customs-form.max-document-weight.error', {
    maxWeight: MAX_DOCUMENT_WEIGHT
  }),
  test: function (option) {
    if (!option || (option === null || option === void 0 ? void 0 : option.value) !== CustomsReasonToExport.DOCUMENTS) {
      return true;
    }
    return customsInventoryMaxWeight <= MAX_DOCUMENT_WEIGHT;
  }
});
const getInvoiceNumberValidation = t => yup.string().when('reasonsToExport', {
  is: getIsSelectOption(CustomsReasonToExport.PURCHASE_OR_SALE),
  then: yup.string().required(getRequiredErrorMessage('customs-form.tax-info.invoice-number-label', t)),
  otherwise: yup.string().nullable()
});

export { MAX_DOCUMENT_WEIGHT, MAX_DOCUMENT_WEIGHT_ERROR, getInvoiceNumberValidation, getReasonsToExportValidation, getTaxFormValidation };
//# sourceMappingURL=taxFormValidation.js.map
